import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Typography, Button, TypographyProps, SxProps } from '@mui/material';
import PuzzleIcon from '@mui/icons-material/Extension';

import { resetAssessQuestions } from '../../../../store/QuestionSlice';
import TutorAssessModal from '../modals/TutorAssessModal';
import { useAppSelector } from '../../../../hooks';
import { getAuthState } from '../../../../store/AuthSlice';
import { createAnalytics } from '../../../../store/AnalyticsSlice';

const divStyles = {
  display: 'inline-block',
  borderRadius: '7px',
  padding: '2px',
  background: 'linear-gradient(45deg, #D889F7, #4585F4)',
  marginRight: '5px',
};

const assessBtnProps: SxProps = {
  borderRadius: '5px',
  backgroundColor: '#F6F8FD',
  padding: '6px 14px',
  fontSize: '16px',
  fontWeight: '600',
  '&:hover': {
    backgroundColor: '#f0f4ff',
  },
};

const introducingTypoProps: TypographyProps = {
  fontSize: '16px',
  fontWeight: '600',
  sx: {
    background: 'linear-gradient(90deg, #DB86F8 0%, #006FD6 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
};

interface TutorAssessProps {
  pageNo: string;
}

const TutorAssess: React.FC<TutorAssessProps> = ({ pageNo }) => {
  const authState = useAppSelector(getAuthState);
  const authUser = authState.user;
  const dispatch = useDispatch();

  const [isTutorAssessModalOpen, setTutorAssessModalOpen] = useState(false);

  const handleAssessClick = () => {
    dispatch(
      createAnalytics({
        type: 'LP - Assess Button Click',
        data: {
          userEmail: authUser?.email,
          userFirstName: authUser?.firstname,
          userLastName: authUser?.lastname,
          userRole: authUser?.role.name,
        },
        userId: authUser?._id,
      })
    );
    setTutorAssessModalOpen(true);
  };

  return (
    <>
      <div style={divStyles}>
        <Button
          className="assess_button"
          color="inherit"
          startIcon={
            <PuzzleIcon
              fontSize="small"
              sx={{
                color: '#DB86F8',
              }}
            />
          }
          sx={assessBtnProps}
          onClick={handleAssessClick}
        >
          <Typography {...introducingTypoProps}>Assess</Typography>
        </Button>
      </div>
      {/* Modals */}
      {isTutorAssessModalOpen && (
        <TutorAssessModal
          open={isTutorAssessModalOpen}
          pageNo={pageNo}
          onClose={() => {
            setTutorAssessModalOpen(false);
            dispatch(resetAssessQuestions());
          }}
        />
      )}
    </>
  );
};

export default TutorAssess;
